import { useMutation } from '@tanstack/react-query';
import { useDataProvider } from 'react-admin';
import type { GPDataProvider } from '../index';
import type {
  MappingRuleCategoryBulkRemapParams,
  MappingRuleCategoryBulkRemapResponse,
} from '../CustomMethods/mappingRuleCategoryBulkRemap';
import { type ActionHook, type ActionOptions } from './types';

export function useMappingRuleCategoryBulkRemap(
  initialArgs?: MappingRuleCategoryBulkRemapParams,
  options?: ActionOptions<MappingRuleCategoryBulkRemapParams, MappingRuleCategoryBulkRemapResponse>,
): ActionHook<MappingRuleCategoryBulkRemapParams, MappingRuleCategoryBulkRemapResponse> {
  const dataProvider = useDataProvider<GPDataProvider>();
  const mutation = useMutation<
    MappingRuleCategoryBulkRemapResponse,
    Error,
    MappingRuleCategoryBulkRemapParams
  >({
    ...options,
    mutationFn: (args) =>
      dataProvider.mappingRuleCategoryBulkRemap(
        args ?? initialArgs ?? ({} as MappingRuleCategoryBulkRemapParams),
      ),
  });
  return [
    (args, callOptions) =>
      mutation.mutateAsync(
        args ?? initialArgs ?? ({} as MappingRuleCategoryBulkRemapParams),
        callOptions,
      ),
    mutation,
  ];
}
